module.exports = require('./helpers/bundle-url').getBundleURL('473Ps') + "logo.c51670a8.svg";